import { ApplicationTypeEnum } from "../../enums/ApplicationTypeEnum";
import { DeviceSubTypeEnum } from "../../enums/DeviceSubTypeEnum";
import { DeviceTypesEnum } from "../../enums/DeviceTypesEnum";
import { eLynxObjectTypeEnum } from "../../enums/eLynxObjectType";
import { LiftTypeEnum } from "../../enums/LiftTypeEnum";
import { RulesEngineRuleTypeEnum } from "../../enums/RulesEngineTypeEnum";
import { makeObjectEquatableKey } from "../../utilities/drcx/MakeObjectEquatableKey";
import { IEquatable } from "../IEquatable";
import { IDRCXConfigurationSectionObjectDTO } from "./DRCXConfigurationSectionObjectDTO";
import { DRCXScheduleModel } from "./DRCXScheduleModel";

export class DRCXConfigurationSectionObjectModel implements IEquatable<string> {
    public id: number | undefined = undefined;
    public objectType: eLynxObjectTypeEnum | undefined = undefined;
    public name: string | undefined = undefined;

    public order: number = 0;
    public excludeObject: boolean = false;
    public includeSubgroups: boolean = false;
    public includeDynamicGroups: boolean = true;
    public targetObjectType: eLynxObjectTypeEnum | undefined = eLynxObjectTypeEnum.Device;
    public deviceType: DeviceTypesEnum | undefined = undefined;
    public tankSubType: DeviceSubTypeEnum | undefined = undefined;
    public applicationType: ApplicationTypeEnum | undefined = undefined;
    public includeWellDevices: boolean = true;
    public liftType: LiftTypeEnum | undefined = undefined;
    public schedule: DRCXScheduleModel | undefined = undefined;
    public ruleType: RulesEngineRuleTypeEnum | undefined = undefined;

    public get equatableKey(): string {
        return makeObjectEquatableKey(
            this.objectType,
            this.id,
            //this.deviceType,
            //this.ruleType
        );
    }

    public constructor(dto?: IDRCXConfigurationSectionObjectDTO) {
        if (dto) {
            if (typeof dto.id !== "undefined") {
                this.id = dto.id;
            }
            if (typeof dto.objectType !== "undefined") {
                this.objectType = dto.objectType;
            }
            if (typeof dto.name !== "undefined") {
                this.name = dto.name;
            }
            if (typeof dto.order !== "undefined") {
                this.order = dto.order;
            }
            if (typeof dto.excludeObject !== "undefined") {
                this.excludeObject = dto.excludeObject;
            }
            if (typeof dto.includeSubgroups !== "undefined") {
                this.includeSubgroups = dto.includeSubgroups;
            }
            if (typeof dto.includeDynamicGroups !== "undefined") {
                this.includeDynamicGroups = dto.includeDynamicGroups;
            }
            if (typeof dto.targetObjectType !== "undefined") {
                this.targetObjectType = dto.targetObjectType;
            }
            if (typeof dto.deviceType !== "undefined") {
                this.deviceType = dto.deviceType;
            }
            if (typeof dto.tankSubType !== "undefined") {
                this.tankSubType = dto.tankSubType;
            }
            if (typeof dto.applicationType !== "undefined") {
                this.applicationType = dto.applicationType;
            }
            if (typeof dto.includeWellDevices !== "undefined") {
                this.includeWellDevices = dto.includeWellDevices;
            }
            if (typeof dto.liftType !== "undefined") {
                this.liftType = dto.liftType;
            }
            if (typeof dto.schedule !== "undefined") {
                this.schedule = dto.schedule
                    ? new DRCXScheduleModel(dto.schedule)
                    : undefined;
            }
            if (typeof dto.ruleType !== "undefined") {
                this.ruleType = dto.ruleType;
            }
        }
    }

    public toDTO(): IDRCXConfigurationSectionObjectDTO {
        return {
            id: this.id,
            objectType: this.objectType,
            order: this.order,
            name: this.name,
            excludeObject: this.excludeObject,
            includeSubgroups: this.includeSubgroups,
            includeDynamicGroups: this.includeDynamicGroups,
            targetObjectType: this.targetObjectType,
            deviceType: this.deviceType,
            tankSubType: this.tankSubType,
            applicationType: this.applicationType,
            includeWellDevices: this.includeWellDevices,
            liftType: this.liftType,
            schedule: this.schedule?.toDTO(),
            ruleType: this.ruleType
        };
    }
}
